import { render, staticRenderFns } from "./instructionalVideo.vue?vue&type=template&id=c462d3a2&scoped=true"
import script from "./instructionalVideo.vue?vue&type=script&lang=js"
export * from "./instructionalVideo.vue?vue&type=script&lang=js"
import style0 from "./instructionalVideo.vue?vue&type=style&index=0&id=c462d3a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c462d3a2",
  null
  
)

export default component.exports